import React, {Component} from 'react';
import prime from './img/prime.PNG';

class About extends Component {


    render(){
        return(
        <div className="about">
          <h1 className="about-heading">About</h1>
          <img className="about-image" src={prime}  alt="Prime number finder"/>
          <p className="about-text">I have a formal education in Electronics and have worked as a technician in the AV space. 
          During my work as a technician I was tasked with performing site visits to gauge customers requirements as well as installation and comissioning of projects in 
          and around Southern Africa. In my role as a software consultant I was tasked with compiling manuals for customers, as well as present database data using html php 
          css and javascript. I have worked extensively with Microsoft server, sql as well as mysql. I am also able to compile reports with PowerBI. </p>

          <p className="about-text">I also have a broad range of soft skills that you can have confidence in for a candidate to be able to work with your employees as well as your customers. 
          It also goes without saying that I have an expert level knowledge of a broad range of computer software and strong communications skills in English. 
          To view a live demo of any of these project please drop me a mail and I can bring my raspberry pi along for demo and interview purposes.</p>
        </div>
        )
    }

}

export default About;